import { BaseModel } from "sjs-base-model";
import SimpleValueModel from "../../models/ValueModel";
import S3FileModel from "../../models/order/S3FileModel";
import configuration from "../../utilities/configuration";
import * as EffectUtility from "../../utilities/EffectUtility";

export async function getAllEmptyOrderFiles() {
    const endpoint = configuration.apiServer + configuration.apiEmptyOrderFilesPath;
    return EffectUtility.getToModel(S3FileModel, endpoint);
}

export async function putEmptyOrderFile(request) {
    const endpoint = configuration.apiServer + configuration.apiEmptyOrderFilesPath;
    return EffectUtility.putToModel(S3FileModel, endpoint, request);
}

export async function getUsersEmptyOrderFiles(orderId) {
    const endpoint = configuration.apiServer + configuration.apiEmptyOrderFilesPath + "/" + orderId;
    return EffectUtility.getToModel(SimpleValueModel, endpoint);
}

export async function deleteEmptyOrderFiles(request) {
    const endpoint = configuration.apiServer + configuration.apiEmptyOrderFilesPath;
    return EffectUtility.deleteToModel(BaseModel, endpoint, request);
}